import * as Mui from '@material-ui/core';
var Accordion = Mui.Accordion, AccordionActions = Mui.AccordionActions, AccordionDetails = Mui.AccordionDetails, AccordionSummary = Mui.AccordionSummary;
export { AccordionActions, AccordionDetails, AccordionSummary };
export default Accordion;
//# sourceMappingURL=index.js.map